import * as Sentry from '@sentry/react';

import {IS_PROD, IS_STAGING} from '@variables';

if (IS_PROD || IS_STAGING) {
  const _ENVIRONMENT = IS_PROD ? 'production' : 'staging';
  Sentry.init({
    dsn: 'https://7f2098403ba0428fa6d99bf0517729e5@sentry.io/199910',
    environment: _ENVIRONMENT,
    // Global var for git commit hash generated and set by webpack config.
    // eslint-disable-next-line no-undef
    release: GITVERSION,
    blacklistUrls: [
      /graph\.facebook\.com/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
      /buy-button-storefront\.min\.js/i,
      /ct\.pinterest\.com/i,
      /www\.google-analytics\.com/i,
      /elev\.io/i,
      /klaviyo\.com/i,
      /doubleclick\.net/i,
      /puppy-feeding-guide/,
      /dog-vomiting-causes-and-treatment/,
    ],
    ignoreErrors: [
      // Error generated by a bug in auto-fill library from browser
      // https://github.com/getsentry/sentry/issues/5267
      /Blocked a frame with origin/,
      /l\.LegacyGlobal\.should_do_lastpass_here/,
      /UET is not defined/,
      /ChunkLoadError/,
      /InvalidAccessError/,
      /l\.input\.focus is not a function/,
      /Assignment to read-only properties is not allowed in strict mode/,
      // Amazon publishing services webcrawler
      /ezDenty/,
      /moat_px/,
      /YT/,
      /dailymotion/,
      /IMUID/,
      /mvpConfig/,
      /outputCurrentConfiguration/,
      /apstagLOADED/,
      /jwDefaults is not defined/,
      /Cannot read properties of undefined (reading 'ns')/,
      /Cannot read properties of undefined (reading 'variables')/,
      // Instagram web browser
      /Can't find variable: _AutofillCallbackHandler/,
      // LogRocket calling a deprecated Zendesk API
      /Method webWidget:on.open does not exist./,
    ],
    whitelistUrls: [
      // Only show errors originating from javascript files hosted on site.
      /\/dist\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
      }),
    ],
    beforeSend: function (event, hint) {
      if (!event.extra) {
        event.extra = {};
      }
      if (hint && hint.originalException instanceof Event) {
        event.extra.isTrusted = hint.originalException.isTrusted;
        event.extra.detail = hint.originalException.detail;
        event.extra.type = hint.originalException.type;
      }
      if (window.LogRocket && window.LogRocket.sessionURL) {
        event.extra.LogRocket = window.LogRocket.sessionURL;
      }
      return event;
    },
  });
}
